import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http, trackEvent } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { startCheckout } from "@/lib/checkout";
import { Card, PageTitle, btnPrimary } from "@/components/portal/ui";
import Deliverable from "@/components/portal/Deliverable";
import { ReviewCallCard } from "@/components/portal/ReviewCallCard";

export default function BlueprintView() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [report, setReport] = useState(undefined);
  useEffect(() => { http.get("/portal/report?product=blueprint").then((r) => { setReport(r.data); if (r.data) trackEvent("blueprint_report_viewed", {}, { once: true }); }).catch(() => setReport(null)); }, []);
  if (report === undefined) return <div className="text-[#6B665E]">Loading…</div>;

  return (
    <div>
      <PageTitle eyebrow="Your $279 Blueprint" title="Personalized Infant Sleep Blueprint"
        sub="Your complete implementation plan, created by your Certified Infant Sleep Consultant — exactly what to do, and in what order." />
      {!report ? (
        <Card className="p-8 text-center">
          <p className="font-display text-2xl text-[#1A1918]">Your Blueprint isn't ready yet</p>
          <p className="text-[#6B665E] mt-2 text-sm">The Blueprint begins with a full planning intake. If you completed the Diagnostic, we carry all of it forward — you only answer the additional questions.</p>
          <button onClick={() => nav("/portal/blueprint-intake")} className={`${btnPrimary} mt-6`}>Start my Blueprint intake</button>
        </Card>
      ) : (
        <>
          <Deliverable report={report} product="blueprint" />
          <ReviewCallCard product="blueprint"
            link="https://calendly.com/thenurturedparentcollective/personalized-sleep-blueprint-walkthrough-w-andreahurley"
            label="Schedule Your Included 45-Minute Blueprint Walkthrough"
            body="Your Blueprint includes one optional 45-minute video walkthrough with Andrea Hurley to walk through your implementation plan and answer questions before you put it into practice on your own. A one-time review — not ongoing coaching."
            eventName="blueprint_walkthrough_call_click" testid="blueprint-walkthrough-call" />
          <Card className="p-6 mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-display text-xl text-[#1A1918]">Want support while you implement?</p>
              <p className="text-[#6B665E] text-sm mt-1">Add Guided Implementation Support — direct help, troubleshooting, and adjustments from your Certified Infant Sleep Consultant.</p>
            </div>
            <button data-testid="blueprint-add-guided-support" onClick={() => startCheckout({ product: "guided_standalone", user, navigate: nav })} className={btnPrimary}>Add Guided Implementation Support — $749</button>
          </Card>
        </>
      )}
    </div>
  );
}
